import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { AuthCallback } from 'components/auth/AuthCallback';
import { LoggedOut } from 'components/auth/LoggedOut';
import { RequireAuth } from 'components/auth/RequireAuth';
import { Feedback } from 'components/feedback/Feedback';
import { StrataSuiteHomeScreen } from 'components/home/StrataSuiteHomeScreen';
import { SidebarPageLayout } from 'components/SidebarPageLayout';
import { SiteSections } from 'components/SiteSections';
import { AppRoutes } from 'services/routes';

export const App = () => (
    <BrowserRouter basename="/">
        <Routes>
            <Route path={AppRoutes.callback} element={<AuthCallback />} />
            <Route path={AppRoutes.loggedOut} element={<LoggedOut />} />
            <Route element={<RequireAuth />}>
                <Route path={AppRoutes.home} element={<StrataSuiteHomeScreen />} />
                <Route path={AppRoutes.feedback} element={<Feedback />} />
                {SiteSections.map(({ title, navTabContent, routes }) => (
                    <Route
                        key={title}
                        element={<SidebarPageLayout navTabContent={navTabContent} />}
                    >
                        {routes.map(({ path, element }) => (
                            <Route key={path} path={path} element={element} />
                        ))}
                    </Route>
                ))}
            </Route>
            <Route path="*" element={<Navigate replace to={AppRoutes.home} />} />
        </Routes>
    </BrowserRouter>
);
